import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBrandCostRequest } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useAddInitialBrandCost(briefId: string) {
  const {
    mutate: addInitialCost,
    isLoading: isAdding,
    isSuccess: isAdded,
  } = useMutation({
    mutationFn: (data: IBrandCostRequest) =>
      BriefService.addIninitalBrandCost(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
    },
  });

  return {
    addInitialCost,
    isAdding,
    isAdded,
  };
}
